export const iconSizes = {
  small: 16,
  medium: 24,
  large: 32,
}
